import Vue from 'vue';

/**
 * Directive to be used in socialmedia to highlight hashtags
 * @module hashtagHighlighter
 * @example
 * <p hashtagHighlighter>Text with #hashtag to be highlighted</p>
 * @see {@link https://vuejs.org/v2/guide/custom-directive.html|Custom Directive}
 */
Vue.directive('hashtagHighlighter', {
    /**
     * Called when the bound element has been inserted into its parent node
     * (this only guarantees parent node presence, not necessarily in-document).
     * replaces text with span
     * @param {HTMLElement} el - Element with text
     */
    inserted: function inserted(el) {
        var regex = /(^|\s)(#[a-z\d-]+)/gi;
        el.innerHTML = el.innerHTML.replace(regex, '<span class="hashtag-highlight">$&</span>');
    },
});
